import { Component, HostListener, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ICWQuestion } from '../../../../../Common/model/cwquestion';
import { CWQuestionService } from '../../services/cwquestion/cwquestion.service';
import { RoutingService } from '../../services/routing-service/routing.service';
import { EditQuestionData } from '../build-crossword/create-edit-question/edit-question.component';
import { CanChildDeactivate, CanComponentDeactivate } from '../util/can.deactivate.component';

@Component({
  selector: 'app-show-edit-question',
  templateUrl: './show-edit-question.component.html',
})
export class ShowEditQuestionComponent implements OnInit, CanComponentDeactivate {
  crosswordBuildId: string;
  cwQuestion: ICWQuestion;
  editQuestionData: EditQuestionData;
  canEditCreateQuestionDeactivate: CanChildDeactivate = {};
  constructor(
    private cwQuestionService: CWQuestionService,
    private translateService: TranslateService,
  ) {}
  async ngOnInit() {
    this.crosswordBuildId = RoutingService.createEditQuestion.getParams().queryParam;
    const questionId = RoutingService.createEditQuestion.getParams().param;
    this.cwQuestion = await this.cwQuestionService.getQuestionByIndexId(questionId);
    this.editQuestionData = {
      cwQuestion: this.cwQuestion,
      crosswordBuildId: this.crosswordBuildId,
      isInFullView: true,
      canOpenInFullView: false,
    };
  }
  onCancel(): void {
    RoutingService.buildCrossword.navigateTo(this.crosswordBuildId);
  }
  hasUnsavedChanges(): boolean {
    return this.canEditCreateQuestionDeactivate.hasUnsavedChanges();
  }
  getUnsavedMessage(): string {
    return this.translateService.instant('messages.crossword-question-not-saved');
  }
  @HostListener('window:beforeunload', ['$event'])
  windowBeforeunload() {
    if (this.hasUnsavedChanges()) {
      return this.getUnsavedMessage();
    }
  }
}
